module.exports = __webpack_public_path__ + "img/15-half-lg.560b0a5e.jpg";